/* unplugin-vue-components disabled */import { render } from "./CompleteOrder.vue?vue&type=template&id=240edc73&scoped=true&ts=true"
import script from "./CompleteOrder.vue?vue&type=script&lang=ts"
export * from "./CompleteOrder.vue?vue&type=script&lang=ts"

import "./CompleteOrder.vue?vue&type=style&index=0&id=240edc73&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-240edc73"]])

export default __exports__